import { FC } from 'react';
import { Alert, Button, Col, Form, Input, InputNumber, message, Row, Spin } from "antd";
import * as React from "react";
import restful from '../../restful';
import SelectRoleField from '../fields/select-role-field';
import Password from 'antd/lib/input/Password';
import SelectPublishField from '../fields/select-publish-field';
import UploadFileField from '../fields/upload-file-field';
import TextArea from 'antd/lib/input/TextArea';
import SelectProductTypeField from '../fields/select-product-type-field';
import SelectUnitField from '../fields/select-unit-field';
import SelectCategoriesField from '../fields/select-category-field';
import SelectForTestField from '../fields/select-for-test-field';
import SelectApiField from '../fields/select-api-field';

interface Prop { id: string | null, onEdit?: () => void, }

const ProductForm: FC<Prop> = ({ id, onEdit }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = React.useState(false)

	React.useEffect(() => {
		if (id === null) return
		setLoading(true)
		restful.get('products/' + id + "/form")
			.then((res) => {
				res.data.result.form.published = res.data.result.form.published + ''
				res.data.result.form.forTest = res.data.result.form.forTest + ''
				form.setFieldsValue(res.data.result.form)
			})
			.catch((err) => message.error(err.message))
			.finally(() => setLoading(false));;
	}, [])

	function onFinish(data: any) {
		setLoading(true)
		restful.request({
			data,
			method: id ? "PUT" : "POST",
			url: id ? `/products/${id}` : "/products"
		}).then((res) => {
			if (id === null) form.resetFields()
			message.success("انجام شد")
			if (onEdit) onEdit()
		})
			.catch((err) => message.error(err.message))
			.finally(() => setLoading(false));
	}

	return (
		<Spin spinning={loading} >
			<Form form={form} onFinish={onFinish} layout="vertical" autoComplete='off'>

				{form.getFieldValue('syncMessage') &&
					<Alert type='error'
						message={form.getFieldValue('syncMessage')}
						style={{ marginBottom: 24 }}
					/>}

				<Row gutter={16}>

					<Col xs={24} md={12}  >
						<Form.Item name="title" label="عنوان"
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<Input />
						</Form.Item>
					</Col>



					<Col xs={24} md={12}  >
						<Form.Item name="code" label="کد"
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<Input />
						</Form.Item>
					</Col>


					<Col xs={24} md={12}  >
						<Form.Item name="image" label="تصویر"
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<UploadFileField />
						</Form.Item>
					</Col>



					<Col xs={24} md={12}  >
						<Form.Item name="description" label="توضیحات"
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<TextArea />
						</Form.Item>
					</Col>


					<Col xs={24} md={12}  >
						<Form.Item name="type" label="نوع"
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<SelectProductTypeField />
						</Form.Item>
					</Col>

					<Col xs={24} md={12}  >
						<Form.Item name="count" label="تعداد"
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<InputNumber style={{ width: "100%" }} />
						</Form.Item>
					</Col>

					<Col xs={24} md={12}  >
						<Form.Item name="cost" label="مبلغ"
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<InputNumber style={{ width: "100%" }} />
						</Form.Item>
					</Col>

					<Col xs={24} md={12}  >
						<Form.Item name="unit" label="واحد"
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<SelectUnitField />
						</Form.Item>
					</Col>

					<Col xs={24} md={12}  >
						<Form.Item name="category" label="دسته" >
							<SelectCategoriesField />
						</Form.Item>
					</Col>

					<Col xs={24} md={12}  >
						<Form.Item name="published" label="انتشار"
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<SelectPublishField />
						</Form.Item>
					</Col>

					<Col xs={24} md={12}  >
						<Form.Item name="forTest" label="تستی"
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<SelectForTestField />
						</Form.Item>
					</Col>

					<Col xs={24} md={12}  >
						<Form.Item name="api" label="ای پی آی"
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<SelectApiField />
						</Form.Item>
					</Col>
					<Col span={24} style={{ textAlign: 'left' }}>
						<Button type="primary" htmlType="submit">ثبت</Button>
					</Col>
				</Row>
			</Form>
		</Spin>
	)
}

export default ProductForm;
